<template>
  <div v-if="access_granted">
  
  
  
  
  <p-button type="danger" @click.prevent="testPopulateNotifications">Test populate notifications</p-button>
  
  
   <div class="card" style="margin-bottom:50px">
          <div class="card-header">
              <h5 class="title">Organizations</h5>
          </div>
          <div class="card-body table-responsive table-full-width">
            <el-table :data="organizations" >
                <el-table-column label="Organization ID" property="id" ></el-table-column>
                <el-table-column label="Organization" property="company_name"></el-table-column>
            </el-table>

          </div>
 </div>
 
 
 
 <div class="card" style="margin-bottom:50px">
 
          <div class="card-header">
              <h5 class="title">Users</h5>
          </div>
          <div class="card-body table-responsive table-full-width">
            <el-table :data="users">
                <el-table-column label="Organization ID" property="user_role.organization_id" ></el-table-column>
                <el-table-column label="User ID" property="id" ></el-table-column>
                <el-table-column label="First Name">
                		<template slot-scope="scope">
                		<span v-if="scope.row.user_info"> 
           					{{scope.row.user_info.first_name}} 
						</span>
						<span v-else>No User Info</span>
          			</template>
                </el-table-column>
                 <el-table-column label="Last Name">
                		<template slot-scope="scope">
                		<span v-if="scope.row.user_info"> 
           					{{scope.row.user_info.last_name}}
						</span>
						<span v-else>No User Info</span>
          			</template>
                </el-table-column>
                <el-table-column label="Email" property="email" ></el-table-column>
                <el-table-column label="User Role">
                		<template slot-scope="scope">
                		<span v-if="scope.row.user_role"> 
           					{{scope.row.user_role.role}} 
						</span>
						<span v-else>No User Role</span>
          			</template>
                </el-table-column>
            </el-table>

          </div>
 </div>
 
 
  <div class="card" style="margin-bottom:50px">
 
          <div class="card-header">
              <h5 class="title">Clients</h5>
          </div>
          <div class="card-body table-responsive table-full-width">
            <el-table :data="clients">
                <el-table-column label="Client ID" property="id" ></el-table-column>
                <el-table-column label="Email" property="email" ></el-table-column>
                
                  <el-table-column label="Access" >
                  		<template slot-scope="scope">
                			<div v-for="ac in scope.row.client_entity_access_rights"> 
           						({{ac.entity_id}}) -  <strong>{{ac.entity.entity_name}}</strong>  - {{ac.role}}
							</div>
          			</template>
                  
                  </el-table-column>
                
                <el-table-column label="Email Verified">
                		<template slot-scope="scope">
                		<span v-if="scope.row.email_verified_at"> 
           					{{scope.row.email_verified_at}} 
						</span>
						<span v-else>-</span>
          			</template>
                </el-table-column>
            </el-table>

          </div>
 </div>
  

  
  
    <h4  slot="header" class="card-title">
    Create New Organization
    </h4>  
 <card class="form-horizontal">
   
    	<collapse>
		<collapse-item title="Create Organization">

    <div class="row" style="text-align:left;">
      <label class="col-sm-2 col-form-label">Company Name</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  v-model="new_org.name">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>

      <div  class="text-center">
      <p-button type="info" @click.prevent="createNewOrg">Create New Organization</p-button>
    </div>
    </collapse-item>
		</collapse>
 </card> 
   
    
    <div><h4 >
    Delete Organization
    </h4>  </div>
    <card class="form-horizontal">
		<collapse>
		<collapse-item title="Delete Organization">
		<div class="row" style="text-align:left;">
		  <label class="col-sm-2 col-form-label">Organization ID</label>
		  <div class="col-sm-7">
			<fg-input type="text"
					  v-model="delete_org.id">
			</fg-input>
		  </div>
		  <div class="col-sm-3 label-on-right">
			<code></code>
		  </div>
		</div>

		  <div  class="text-center">
		  <p-button type="danger" @click.prevent="deleteOrg">Delete Org</p-button>
		</div>

	   </collapse-item>
		</collapse>
    </card>      
    
    
    <div><h4 >
    Edit User
    </h4>  </div>
    <card class="form-horizontal">
		<collapse>
		<collapse-item title="Edit User">
		
		
		<div class="row" style="text-align:left;">
		  <label class="col-sm-2 col-form-label">User ID</label>
		  <div class="col-sm-7">
			<fg-input type="text"
					  v-model="edit_user.user_id">
			</fg-input>
		  </div>
		  <div class="col-sm-3 label-on-right">
			<code></code>
		  </div>
		</div>
		
		<div class="row" style="text-align:left;">
		  <label class="col-sm-2 col-form-label">Organization ID</label>
		  <div class="col-sm-7">
			<fg-input type="text"
					  v-model="edit_user.org_id">
			</fg-input>
		  </div>
		  <div class="col-sm-3 label-on-right">
			<code></code>
		  </div>
		</div>

		<div class="row" style="text-align:left;">
		  <label class="col-sm-2 col-form-label">First Name</label>
		  <div class="col-sm-7">
			<fg-input type="text"
					  v-model="edit_user.first_name">
			</fg-input>
		  </div>
		  <div class="col-sm-3 label-on-right">
			<code></code>
		  </div>
		</div>
		
		<div class="row" style="text-align:left;">
		  <label class="col-sm-2 col-form-label">Last Name</label>
		  <div class="col-sm-7">
			<fg-input type="text"
					  v-model="edit_user.last_name">
			</fg-input>
		  </div>
		  <div class="col-sm-3 label-on-right">
			<code></code>
		  </div>
		</div>

		
		<div class="row">
      <label class="col-sm-2 col-form-label">Role</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder=""
                             v-model="edit_user.role">
                    <el-option v-for="option in selects.roles"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>


		  <div  class="text-center">
		  <p-button type="danger" @click.prevent="editUser">Edit User</p-button>
		</div>

	   </collapse-item>
		</collapse>
    </card>      
   
   
   
   
       <h4  slot="header" class="card-title">
    Bulk Import
    </h4>  
 <card class="form-horizontal">
   
    	<collapse>
		<collapse-item title="Bulk Import">
		
			 <div  class="text-center">
		 		 <p-button type="danger" @click.prevent="bulkImport">Bulk Import From Server File</p-button>
				</div>
		</collapse-item>
		</collapse>
	</card>		     
 
   


  </div>
  <div v-else>
  <h1>Oops! What are you looking for?</h1>
  </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {
     	
    				

     
			let uri = this.$base_url+'/api/v1/sadmin/get/info';
			 ApiService.get(uri).then(response => {
			 	if(response.data.Success == "success"){
			 		this.access_granted = true;
			 	}

				this.organizations = response.data.organizations;
				this.users = response.data.users;
				this.clients = response.data.clients;
			})
      
     	 	
      
    },
    
     
    data () {
      return {
        coy:[],
        variables:[],
        clients:[],
        organizations:[],
        access_granted:false,
        users:[],
    	eid: this.$route.params.eid,
    	oid: this.$route.params.oid,
    	new_org: {
    		name:''
    	},
    	delete_org:{
    		id:''
    	},
    	edit_user:{
    		user_id:'',
    		org_id:'',
    		first_name:'',
    		last_name:'',
    		role:'',
    	
    	},
      
        modelValidations: {
          title: {
          },
          description: {
          },
          amount: {
            required: true,
            decimal:true,
          },
          due_date: {
          	required: true,
          },
         
          
        },
        
        selects: {
          currencies: [
            {value: "SGD", label: 'SGD'},
		   ],
		   roles: [
            {value: "view", label: 'View'},
            {value: "edit", label: 'Edit'},
            {value: "admin", label: 'Admin'},
            {value: "client", label: 'Client'},
            {value: "associate", label: 'Associate'},
		   ],
		  billing_cycle:[
            {value: 1, label: 'Annually'},
            {value: 2, label: 'Monthly'},
		   ],
		   category:[
            {value: 1, label: 'Annual Subscription Fee'},
		   ] 
        },
      }
    },
    methods:{
      goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
       displayErrorMessage(msg){
        		swal({
					  title: 'Error!',
					  text: msg,
					  type: 'error',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
			 	})
        
        
        
        },
    	
      createNewOrg() {
      		const vm = this;
        	let uri = this.$base_url+'/api/v1/sadmin/create/org';
      		ApiService.post(uri, this.new_org).then(response => {
      				swal({
					  title: 'Done!',
					  text: 'New organization created',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					}).then(function(){
			
					vm.$router.go()
				
				})
         		
     		 })
      },
       bulkImport() {
      		const vm = this;
        	let uri = this.$base_url+'/api/v1/sadmin/bulk/import';
      		ApiService.post(uri, this.new_org).then(response => {
      				swal({
					  title: 'Done!',
					  text: 'Bulk Import Done',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					}).then(function(){
			
				
				})
         		
     		 })
      },
      testPopulateNotifications(){
      
   			//let uri = this.$base_url+'/api/v1/sadmin/test_send_notifications_email';
      		let uri = this.$base_url+'/api/v1/sadmin/test_populate_notifications';
      		ApiService.get(uri).then(response => {
      		
      		
      		
      		});
      
      
      
      
      },
      editUser() {
      		const vm = this;
        	let uri = this.$base_url+'/api/v1/sadmin/edit/user';
      		ApiService.post(uri, this.edit_user).then(response => {
      				swal({
					  title: 'Done!',
					  text: 'User Edited',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					}).then(function(){
			
					vm.$router.go()
				
				})
         		
     		 })
      },
       deleteOrg(oid) {
  
       	const vm = this;
       	
       	swal({
            title: 'Are you sure?',
            text: 'You can\' revert this!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Yes, delete it!',
            buttonsStyling: false
          }).then(function () {
             	const vm_ = vm;
          	 let uri = vm.$base_url+'/api/v1/sadmin/delete/org/'+ vm.delete_org.id;
     		  ApiService.get(uri).then(response => {
				swal({
				  title: 'Deleted!',
				  text: 'The organization has been deleted.',
				  type: 'success',
				  confirmButtonClass: 'btn btn-success btn-fill',
				  buttonsStyling: false
				}).then(function(){
			
					vm.$router.go()
				
				})
				//end swal
            })
         
            
          })
       }, //end  
       
      editInvoice() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		
  		  } else {
    		let uri = this.$base_url+'/api/v1/accounting/update/invoice/'+this.$route.params.iid;
      		ApiService.post(uri, this.model).then(response => {
         			this.$router.push( '/view-entity/'+ this.$route.params.eid);
         			
     		 })
  		  }
        
         
        })
      },///end validate+edit
      
      
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


